import { CalendarDays } from "lucide-react";
import React from "react";

const NoMeetsComp = ({ title = "No Loopps Today!" }) => {
  return (
    <div className="no-meetings-comp w-full col-span-12 rounded-[22px] bg-white/24">
      <div className="flex flex-col items-center justify-between gap-4 py-12 h-full w-full rounded-[inherit]">
        <CalendarDays className="size-19.5 text-glass-foreground" strokeWidth={1} />
        <div className="flex flex-col gap-3">
          <h2 className="text-lg font-bold text-accent dark:text-glass-foreground-muted">{title}</h2>
          <p className="text-sm text-muted text-center">
            You're all caught up. <br /> Everyone's in the loop
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoMeetsComp;
